import React from "react";

import { Box, FlexBox, Heading } from "@braze/beacon-core";
import { StyledOptionLabel } from "@braze/beacon-lab-select/dist/components/Select/OptionLabel";
import { getSpacing } from "@braze/beacon-styling";

import type { CountryCodeType } from "../types";

export const CountryCodeSelectOption = (data: CountryCodeType) => {
  return (
    <StyledOptionLabel>
      <FlexBox mr="md" alignItems="center" direction="row" gap={getSpacing("md") as unknown as string}>
        <Box>{data.flag}</Box>
        <Heading level={6}>+{data.phoneCode}</Heading>
      </FlexBox>
    </StyledOptionLabel>
  );
};
